export const SousDispositif = [
  'ContratProfessionnalisation',
  'ContratProfessionnalisationExperimental',
  'Prodiat',
  'ContratProfessionnalisationHope',
] as const

export type SousDispositif = (typeof SousDispositif)[number]

export const SousDispositifLibelle: Record<SousDispositif, string> = {
  ContratProfessionnalisation: 'Contrat de Professionnalisation',
  ContratProfessionnalisationExperimental: 'Contrat de Professionnalisation expérimental',
  Prodiat: 'Contrat de Professionnalisation ProDiat',
  ContratProfessionnalisationHope: 'Contrat de Professionnalisation Hope',
} as const
